import { useEffect, useState, memo } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

// i18next
import i18n from 'i18next';
// import { useTranslation } from 'react-i18next';

// @mui
import { Divider, MenuItem, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// components
import Iconify from '../../components/iconify';

// store
import { I18_NEXT_LNG } from '../../store/types';
import { LocalStorage } from '../../utils/storage';
import { SvgChevronDownFill, SvgWorldFill } from '../../components/SvgIcons';
import { IconPopover } from '../@popover/IconPopover';
// import { HEADER } from '../../../store/constant';


/* ======================================================================================= */

const LANGS = [
    {
        value: 'zh_CN',
        label: '簡體中文'
    },
    {
        value: 'zh_TW',
        label: '繁體中文'
    },
    {
        value: 'en_US',
        label: 'English'
    },
];


/* ======================================================================================= */


const LanguagePopover = ({ textColor = `#FFFFFF`, iconColor = '#FFFFFF', position = { x: '-28px' }, text = false, arrow = false, disabledHoverLine = false }) => {
    const theme = useTheme();
    // const { t } = useTranslation();

    const { lngOptions } = useSelector((state) => state?.account);
    const [ initial, ...known ] = lngOptions || [];

    const [language, setLanguage] = useState(initial);

    // 選擇語言
    const switchLanguage = (option) => {
        setLanguage(option);
        window.location.reload();
        LocalStorage.set(I18_NEXT_LNG, option.value);
        i18n?.changeLanguage(option.value);
        // setStorage(USER_DEFAULT_AREA, {
        //   ...getStorage(USER_DEFAULT_AREA),
        //   defaultLanguageCode: option.value,
        //   defaultLanguageName: option.label
        // });
    };

    useEffect(() => {
        const lang = LocalStorage.get(I18_NEXT_LNG);
        if (lang) {
          const item = lngOptions?.find((option) => option.value === lang);
            // switchLanguage(item)
            setLanguage(() => lngOptions?.find((option) => option.value === lang));
        } else {
            // switchLanguage(initial)
            // 如果被清空了 那么当前语言会被设置为默认语言 zh-cn
            setLanguage(initial);
        }
    }, [lngOptions]);

    return (
      <IconPopover
        position={position}
        disabledHoverLine={disabledHoverLine}
        primary={
          <Stack direction={'row'} alignItems={`center`}>
            <SvgWorldFill color={iconColor} />
            {
              text && (
                <Typography variant={'body2'} fontWeight={700} color={textColor}>{ language?.label }</Typography>
              )
            }
            {
              arrow && (
                <>
                  <Divider sx={{ height: 22, alignSelf: 'center', mx: 1, my: 0, borderColor: 'rgba(50, 96, 201, 0.20)' }}  orientation="vertical" variant="middle" flexItem />
                  <SvgChevronDownFill color={textColor} />
                </>
              )
            }
          </Stack>
        }
        content={
            <Stack
              minWidth={104}
              p={1}
              component={'ul'}
              spacing={0.75}
              sx={{
                  '& .MuiMenuItem-root': {
                      color: 'common.black',
                      fontWeight: 700,
                      fontSize: 16,
                      px: 1.5,
                      py: 1,
                      transition: 'all 300ms ease',
                      ...theme.typography.hoverPrimaryUnderline2px,
                  },
                  '& .MuiMenuItem-root.Mui-selected, & .MuiMenuItem-root:hover': {
                      color: 'color.primaryBlue3',
                  },
                  '& .MuiMenuItem-root.Mui-selected': {
                      backgroundColor: 'transparent',
                  },
                  '& .MuiMenuItem-root:hover': {
                      backgroundColor: `${theme.palette.action.hover} !important`,
                  }
              }}
            >
                {_.map(lngOptions, (option) => (
                  <MenuItem
                    key={option.value}
                    selected={option.value === i18n.language}
                    onClick={() => switchLanguage(option)}
                  >
                      {option.label}
                  </MenuItem>
                ))}
            </Stack>
        }
      />
    );
};

export default memo(LanguagePopover);
